import React from 'react'
import Header from '../components/Header'
import './Home.css'

const Home = () => {
  return (
    <>
          <Header/>
    </>
  )
}

export default Home